import React from 'react';

export default function MotionAccuracy({ accuracy, compact = false }) {
  const hasScore = accuracy?.total > 0 && Number.isFinite(accuracy?.percent);
  const score = hasScore ? `${accuracy.percent.toLocaleString('en-GB', { maximumFractionDigits: 1 })}%` : '—';
  const explanation = !accuracy ? 'Accuracy is temporarily unavailable.' : hasScore
    ? `${accuracy.correct.toLocaleString('en-GB')} of ${accuracy.total.toLocaleString('en-GB')} confirmed tracks matched the final community or staff decision.`
    : 'No confirmed tracks to score yet.';
  const description = `${explanation} Pending tracks and “Not sure” answers are excluded. Accuracy checks animal versus false alarm, not species. Updates about once a minute.${accuracy?.stale ? ' Showing the last available score while reconnecting.' : ''}`;
  return <span className={`cr-motion-accuracy${compact ? ' cr-motion-accuracy--compact' : ''}`} aria-label={`Your accuracy: ${score}${accuracy?.stale ? ' (last available)' : ''}`}>
    <span title={description} aria-label={description} tabIndex={0}>Accuracy: <strong>{score}</strong>{accuracy?.stale && ' (saved)'}</span>
  </span>;
}
